import React, { useEffect, useState } from "react";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { getProfile, updateProfile } from "./api";
import "./Profile.css";

function Profile({ onLogout }) {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ nom: "", email: "", mot_de_passe: "", mot_de_passe_actuel: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("account");

  useEffect(() => {
    const token = localStorage.getItem("token");
    getProfile(token)
      .then(user => {
        setUser(user);
        setForm({
          nom: user.nom || "",
          email: user.email || "",
          mot_de_passe: "",
          mot_de_passe_actuel: ""
        });
      })
      .catch(err => console.error("Erreur getProfile :", err));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    // Effacer les messages d'erreur quand l'utilisateur tape
    if (error) setError("");
    if (message) setMessage("");
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    setError("");
    setMessage("");
    
    try {
      // Validation côté client pour le changement de mot de passe
      if (activeTab === "password" && form.mot_de_passe.trim() !== "") {
        if (!form.mot_de_passe_actuel.trim()) {
          setError("Le mot de passe actuel est requis pour changer le mot de passe");
          return;
        }
        if (form.mot_de_passe.trim().length < 4) {
          setError("Le nouveau mot de passe doit contenir au moins 4 caractères");
          return;
        }
      }

      const updated = await updateProfile(token, form);
      setUser(updated);
      
      if (activeTab === "password" && form.mot_de_passe.trim() !== "") {
        setMessage("Mot de passe modifié avec succès ! Vous allez être déconnecté.");
        // Vider les champs de mot de passe
        setForm(prev => ({ ...prev, mot_de_passe: "", mot_de_passe_actuel: "" }));
        // Déconnexion après 2 secondes
        setTimeout(() => {
          onLogout();
        }, 2000);
      } else {
        setMessage("Profil mis à jour !");
      }
    } catch (err) {
      if (err.message && err.message.includes("mot de passe actuel est incorrect")) {
        setError("Le mot de passe actuel est incorrect");
      } else if (err.message && err.message.includes("mot de passe actuel est requis")) {
        setError("Le mot de passe actuel est requis pour changer le mot de passe");
      } else {
        setError("Erreur lors de la mise à jour.");
      }
    }
  };

  const clearMessages = () => {
    setMessage("");
    setError("");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    clearMessages();
    // Vider les champs de mot de passe quand on change d'onglet
    if (tab === "account") {
      setForm(prev => ({ ...prev, mot_de_passe: "", mot_de_passe_actuel: "" }));
    }
  };

  return user ? (
    <div className="profile-outer">
      <div className="profile-card2 profile-card-tabs">
        <div className="profile-avatar2">
          <span>{form.nom ? form.nom[0].toUpperCase() : "?"}</span>
        </div>

        <div className="profile-tabs">
          <div className="tabs-list">
            <button
              className={`tabs-trigger ${activeTab === "account" ? "active" : ""}`}
              onClick={() => handleTabChange("account")}
              type="button"
            >
              Compte
            </button>
            <button
              className={`tabs-trigger ${activeTab === "password" ? "active" : ""}`}
              onClick={() => handleTabChange("password")}
              type="button"
            >
              Mot de passe
            </button>
          </div>

          {activeTab === "account" && (
            <div className="tab-card">
              <div className="tab-card-header">
                <div className="tab-card-title">Compte</div>
                <div className="tab-card-description">Modifiez les informations de votre compte puis enregistrez.</div>
              </div>
              <div className="tab-card-content">
                <div className="form-grid one-col">
                  <div className="field">
                    <label htmlFor="profil-nom" className="field-label">Nom</label>
                    <input id="profil-nom" name="nom" value={form.nom} onChange={handleChange} className="profile-input field-control" />
                  </div>
                  <div className="field">
                    <label htmlFor="profil-email" className="field-label">Email</label>
                    <input id="profil-email" name="email" value={form.email} onChange={handleChange} className="profile-input field-control" type="email" />
                  </div>
                </div>
              </div>
              <div className="tab-card-footer">
                {error && (
                  <div className="alert alert-destructive" role="alert">
                    <div className="alert-icon"><WarningCircle size={20} weight="duotone" /></div>
                    <div className="alert-content">
                      <div className="alert-title">Erreur</div>
                      <div className="alert-description">{error}</div>
                    </div>
                  </div>
                )}
                {message && (
                  <div className="alert alert-success" role="alert">
                    <div className="alert-icon"><CheckCircle size={20} weight="duotone" /></div>
                    <div className="alert-content">
                      <div className="alert-title">Succès !</div>
                      <div className="alert-description">{message}</div>
                    </div>
                  </div>
                )}
                <div className="profile-btns">
                  <button className="profile-save2" onClick={handleSave}>Save changes</button>
                </div>
              </div>
            </div>
          )}

          {activeTab === "password" && (
            <div className="tab-card">
              <div className="tab-card-header">
                <div className="tab-card-title">Mot de passe</div>
                <div className="tab-card-description">Changez votre mot de passe. Après sauvegarde vous serez déconnecté.</div>
              </div>
              <div className="tab-card-content">
                <div className="form-grid one-col">
                  <div className="field">
                    <label htmlFor="profil-mdp-actuel" className="field-label">Current password</label>
                    <input id="profil-mdp-actuel" name="mot_de_passe_actuel" value={form.mot_de_passe_actuel} onChange={handleChange} className="profile-input field-control" type="password" />
                  </div>
                  <div className="field">
                    <label htmlFor="profil-mdp-nouveau" className="field-label">New password</label>
                    <input id="profil-mdp-nouveau" name="mot_de_passe" value={form.mot_de_passe} onChange={handleChange} className="profile-input field-control" type="password" />
                  </div>
                </div>
              </div>
              <div className="tab-card-footer">
                {error && (
                  <div className="alert alert-destructive" role="alert">
                    <div className="alert-icon"><WarningCircle size={20} weight="duotone" /></div>
                    <div className="alert-content">
                      <div className="alert-title">Erreur</div>
                      <div className="alert-description">{error}</div>
                    </div>
                  </div>
                )}
                {message && (
                  <div className="alert alert-success" role="alert">
                    <div className="alert-icon"><CheckCircle size={20} weight="duotone" /></div>
                    <div className="alert-content">
                      <div className="alert-title">Succès !</div>
                      <div className="alert-description">{message}</div>
                    </div>
                  </div>
                )}
                <div className="profile-btns">
                  <button className="profile-save2" onClick={handleSave}>Save password</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="profile-outer">
      <div className="profile-card2">
        <p>Chargement...</p>
      </div>
    </div>
  );
}

export default Profile;